<template>
  <el-row class="orderrecord_framework">
    <el-col :span="24">
      <el-tabs v-model="activeTabPanName">
        <el-tab-pane name="CompletedOrder">
          <div slot="label" class="tab_title">
            <span>已完成</span>
          </div>
          <completed-order v-if="isCompletedOrder"></completed-order>
        </el-tab-pane>
        <el-tab-pane label="已关闭" name="RefundedOrder">
          <div slot="label" class="tab_title">
            <span>已关闭</span>
          </div>
          <refunded-order v-if="isRefundedOrder"></refunded-order>
        </el-tab-pane>
        <el-tab-pane label="已取消" name="CanceledOrder">
          <div slot="label" class="tab_title">
            <span>已取消</span>
          </div>
          <canceled-order v-if="isCanceledOrder"></canceled-order>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
  import CompletedOrder from "./OrderRecord/CompletedOrder.vue"
  import RefundedOrder from "./OrderRecord/RefundedOrder.vue"
  import CanceledOrder from "./OrderRecord/CanceledOrder.vue"

  export default {
    name: "OrderRecord",
    components: {
      CompletedOrder,
      RefundedOrder,
      CanceledOrder
    },
    data() {
      return {
        activeTabPanName: "CompletedOrder",
        isCompletedOrder: true,
        isRefundedOrder: false,
        isCanceledOrder: false,
      };
    },
    watch: {
      activeTabPanName: {
        handler: function (val) {
          this.isCompletedOrder = false;
          this.isRefundedOrder = false;
          this.isCanceledOrder = false;
          switch (val) {
          case "CompletedOrder":
            this.isCompletedOrder = true;
            break;
          case "RefundedOrder":
            this.isRefundedOrder = true;
            break;
          case "CanceledOrder":
            this.isCanceledOrder = true;
            break;
          default:
            break;
          }
        }
      },
    },
    methods: {},
  };
</script>

<style>
  .orderrecord_framework {
    padding-left: 20px;
  }

  .tab_title {
    margin: 0 20px;
    font-size: 16px;
  }

  .el-tabs__nav-scroll {
    padding-top: 15px;
    padding-left: 20px;
    height: 40px;
  }
</style>